import React from 'react';
import PropTypes from 'prop-types';
import MediaFilter from './MediaFilter';
import { partial } from 'lodash';
import './MediaFilters.css';

function MediaFilters({ mediaType, updateMediaType }) {

  const filters = [
    { displayName: 'All of CBC', mediaType: 'all' },
    { displayName: 'News', mediaType: 'news' },
    { displayName: 'Sports', mediaType: 'sports' }
  ];

  return (
    <div className="mediaFilters">
      <span className="sr-only">Search Filters: </span>
      {
        filters
        .map(
          (filter, i) => {
            const updateMediaTypeToFilter = partial(updateMediaType, filter.mediaType);
            const props = { key: i, filter, updateMediaTypeToFilter, mediaType };
            return <MediaFilter {...props} />;
          }
        )
        .reduce((prev, curr) => [prev, ' | ', curr])
      }
    </div>
  );
}

export default MediaFilters;

MediaFilters.propTypes = {
  mediaType: PropTypes.string.isRequired,
  updateMediaType: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MediaFilters.js